export default "__VITE_PUBLIC_ASSET__0ce9e75e__"